import type { ComponentType } from 'react';
import LottieReact, { type LottieComponentProps } from 'lottie-react';

type WrappedLottieModule = {
  default?: ComponentType<LottieComponentProps>;
};

const resolveLottieComponent = (module: unknown): ComponentType<LottieComponentProps> => {
  if (typeof module === 'function') {
    return module as ComponentType<LottieComponentProps>;
  }

  if (module && typeof module === 'object' && typeof (module as WrappedLottieModule).default === 'function') {
    return (module as WrappedLottieModule).default!;
  }

  throw new Error('Unable to resolve lottie-react component');
};

const LottieComponent = resolveLottieComponent(LottieReact);

export const LottieAnimation = (props: LottieComponentProps) => <LottieComponent {...props} />;
